/**
 * The app recipes as data (Mac recipes R3): one file per app, collected here through the
 * non-throwing `defineRecipes`, so one bad entry is dropped with its reason, never a throw at
 * import. Every entry passes the program lint (os-recipes-data.test.ts) and ships held until
 * its app's drill lifts it (runtime_config `mac_recipe_lift`).
 */
import { defineRecipes } from '../os-recipes.js';
import { RECIPES as slack } from './slack.js';
import { RECIPES as mail } from './mail.js';
import { RECIPES as messages } from './messages.js';
import { RECIPES as whatsapp } from './whatsapp.js';
import { RECIPES as zoom } from './zoom.js';
import { RECIPES as notes } from './notes.js';
import { RECIPES as reminders } from './reminders.js';
import { RECIPES as calendar } from './calendar.js';
import { RECIPES as finder } from './finder.js';
import { RECIPES as keynote } from './keynote.js';
import { RECIPES as chrome } from './chrome.js';
import { RECIPES as safari } from './safari.js';
import { RECIPES as notion } from './notion.js';
import { RECIPES as linear } from './linear.js';
import { RECIPES as figma } from './figma.js';
import { RECIPES as spotify } from './spotify.js';
import { RECIPES as photos } from './photos.js';
import { RECIPES as facetime } from './facetime.js';
import { RECIPES as system } from './system.js';
import { RECIPES as excel } from './excel.js';

export { SYSTEM_TOPIC_WORDS } from './system.js';

const defined = defineRecipes([...slack, ...mail, ...messages, ...whatsapp, ...zoom, ...notes, ...reminders, ...calendar, ...finder, ...keynote, ...chrome, ...safari, ...notion, ...linear, ...figma, ...spotify, ...photos, ...facetime, ...system, ...excel]);
export const APP_RECIPES = defined.recipes;
export const APP_RECIPES_DROPPED: readonly string[] = defined.dropped;
